<template>
  <div id="app">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <component :is="currentPage" v-bind="currentPageProps" @change-page="tryChangePage"/>
  </div>
</template>

<script>
import IntroducingPage from "./components/IntroducingPage.vue";
import UploadingPage from "./components/Desktop/UploadingPage.vue";
import UploadingPageMobile from "./components/Mobile/UploadingPageMobile.vue";
import SuccessPage from "./components/SuccessPage.vue";
import ErrorPage from "./components/ErrorPage.vue";
import ApiClientUserMixin from './components/mixins/ApiClientUserMixin.js';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Errors from './errors.js'
const pageTitle = 'Прием кандидата';

export default {
 name: "app",
 components : {
    IntroducingPage,
    UploadingPage,
    UploadingPageMobile,
    SuccessPage,
    ErrorPage,
    Loading
  },
  mixins: [ApiClientUserMixin],
  data() {
    return {
      currentPage: IntroducingPage,
      currentPageProps: null,
      apiClient: {
        token: null,
        packageId: null,
        baseUrl: process.env.VUE_APP_API_URL
      },
      isLoading: false
    };
  },
  mounted() {
    document.title = pageTitle;
    this.getTokenFromUrl();
    if (this.token)
      this.validateToken();
  },
  methods: {
    getTokenFromUrl() {
      let url = new URL(window.location.href);
      let token = url.pathname.split('/').splice(1)[0];
      this.$data.apiClient.token = token;

      if (!this.token || this.token.length < 30) {
        this.tryChangePage("error", Errors.IncorrectLink)
        return;
      }
    },
    validateToken() {
      
      let component = this;
      this.isLoading = true;
      
      axios.get(`${this.baseUrl}/tokens/${this.token}`)
        .then(result => {

          if (result.status === 404)
            component.tryChangePage("error", Errors.IncorrectLink);

          if (result.data.isActive !== true)
            component.tryChangePage("error", Errors.ExpiredLink);

          if (result.data.isSent)
            component.tryChangePage("success");

          component.$data.apiClient.packageId = parseInt(result.data.packageId);
        })
        .catch(() => component.tryChangePage("error", Errors.InternalServerError))
        .finally(() => component.isLoading = false);
    },
    isMobileDevice() {
      const mobileMaxHeight = process.env.VUE_APP_MOBILE_CRITERIA_HEIGHT;
      const mobileMaxWidth = process.env.VUE_APP_MOBILE_CRITERIA_WIDTH;

      if (mobileMaxHeight && document.documentElement.clientHeight <= mobileMaxHeight)
        return true;
      if (mobileMaxWidth && document.documentElement.clientWidth <= mobileMaxWidth)
        return true;
        
      return false;
    },
    tryChangePage(page, props) {
      if (page === "uploading") {
        this.currentPage = this.isMobileDevice()
          ? UploadingPageMobile
          : UploadingPage;
      }
      else if (page === "success") this.currentPage = SuccessPage;
      else if (page === "error") this.currentPage = ErrorPage;
      else return;
      
      this.currentPageProps = props;
    }
  },
};
</script>

<style lang="scss">
@import "../src/styles/fonts.scss";
@import "../src/styles/reset.scss";
@import "../src/styles/shared.scss";
@import "../src/styles/site.scss";

#app {
  width: 100%;
  height: 100%;
}
</style>